














import {
    Prop,
    Component,
    Vue,
    Inject,
    Provide,
    ProvideReactive,
} from "vue-property-decorator";

@Component({
    inject: []
})
export default class AbcStepper extends Vue {
    @Prop() value!: number;
    @Prop({ type: Boolean }) vertical!: boolean;
    @Prop() numberOfSteps!: number;

    @ProvideReactive("isVertical")
    get isVertical(){
        return this.vertical;
    }

    @ProvideReactive("numberOfSteps")
    get numOfSteps() {
        return this.numberOfSteps;
    }

    @ProvideReactive("curStep")
    get curStep() {
        return this.value;
    }

    set curStep(val: number) {
        this.$emit("input", val);
    }

    @Provide("changeStep")
    changeStep(step: number): void {
        this.curStep = step;
    }
}
